import { FC, useState } from 'react'

import { Button } from '../Button/Button.js'
import { ButtonGroup } from '../Button/ButtonGroup.js'
import { FormControlLayout } from './FormControlLayout.js'
import { FormControlButtonGroupSelectProps } from './types.js'
import { extractLayoutProps } from './utils.js'

export const FormControlButtonGroupSelect: FC<
  FormControlButtonGroupSelectProps
> = props => {
  const { items, value, onChange, fullWidth, ...rest } = props

  const { layoutProps, inputProps } = extractLayoutProps(rest)

  const [selected, setSelected] = useState(value)
  return (
    <FormControlLayout {...layoutProps}>
      <ButtonGroup className={fullWidth ? 'w-full' : null} {...inputProps}>
        {items.map(({ icon, text, value }) => (
          <Button
            key={value}
            leadingIcon={icon}
            fullWidth={fullWidth}
            className={fullWidth ? 'flex-1' : null}
            disabled={selected && selected === value}
            onClick={() => {
              setSelected(value)
              if (typeof onChange !== 'undefined') {
                onChange(value)
              }
            }}
          >
            {text}
          </Button>
        ))}
      </ButtonGroup>
    </FormControlLayout>
  )
}
